import * as React from 'react';
import {
  iconButtonBase,
  iconButtonSize,
  iconButtonVariant,
} from 'bento/IconButton/iconButtonCssDefs';
import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from '@material-ui/core/IconButton';

export interface IconButtonProps
  extends Pick<MuiIconButtonProps, Exclude<keyof MuiIconButtonProps, 'color' | 'size'>> {
  ['aria-label']: string;
  component?: React.ElementType;
  color?: 'danger' | 'primary' | 'subtle' | 'contrast' | 'internal';
  href?: string;
  size?: 'small' | 'medium' | 'large';
  target?: string;
  to?: string;
  variant?: 'contained' | 'outlined' | 'text';
}

/**
 * A styled IconButton component that adds variants modeled after our standard Button.
 * Supported variants are "outlined", "contained" and "text" (default). To use different sizes
 * set the size prop on the icon itself.  Supported sizes are "small", "default" and "large".
 *
 * @see {@link https://material-ui.com/api/icon-button/} Material API docs for props
 * @deprecated Deprecated — use pantry IconButton instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-iconbutton--docs
 * Migration: Replace IconButton with the pantry IconButton component.
 */
export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, className, color = 'primary', size = 'medium', variant = 'text', ...rest }, ref) => {
    return (
      <MuiIconButton
        className={className}
        css={(theme) => [
          iconButtonBase(theme, color),
          iconButtonSize(theme, size),
          iconButtonVariant(theme, variant),
        ]}
        ref={ref}
        {...rest}
      >
        {children}
      </MuiIconButton>
    );
  }
);
